import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'facility_has_not_taken_proper_steps_ensure_that'

export const dataPointDefinition = {
  retracedId: 'facility_has_not_taken_proper_steps_ensure_that',
  name: 'Facility has not taken the proper steps to ensure that workers are not exposed to asbestos',
  description:
    'Regardless of whether Asbestos Containing Material (ACM) is present or not, is the facility ensuring workers are not exposed to asbestos? ',
  meta: {
    slcpMeta: {
      key: 'hs-bui-57x',
      number: 'HS-BUI-16-2',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-bui-57x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29840,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
